import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    // Écoute les événements de Turbo pour afficher/cacher le spinner
    this.showSpinner = this.showSpinner.bind(this)
    this.hideSpinner = this.hideSpinner.bind(this)

    document.addEventListener("turbo:before-fetch-request", this.showSpinner)
    document.addEventListener("turbo:frame-load", this.hideSpinner)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.showSpinner)
    document.removeEventListener("turbo:frame-load", this.hideSpinner)
  }

  showSpinner(event) {
    if (event.target.id === "dashboard-content") {
      this.spinnerTarget.classList.remove("hidden")
    }
  }

  hideSpinner(event) {
    if (event.target.id === "dashboard-content") {
      this.spinnerTarget.classList.add("hidden")
    }
  }
}
